import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";
import {findIn, addClass, findAll, closest} from "@elements/dom-utils";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import Tabs from 'bootstrap/js/dist/tab';
onFind('[data-bs-toggle="tab"]',function (element) {
    new Tabs(element);
});

import Popover from 'bootstrap/js/dist/popover';
onFind('[data-bs-toggle="popover"]',function (element) {
    if (element.getAttribute('data-content-url')) {
        new Popover(element, {
            trigger: 'focus',
            container: closest('.modal', element) ? closest('.modal', element) : 'body',
            html: true,
            content: '<div class="js-dynamic-modal__content"><div class="loading-overlay loading-overlay--content loading-overlay--content-sm js-dynamic-modal__loading" hidden><div><div class="loading-spinner"><div class="loading-spinner__item loading-spinner__item--1"></div><div class="loading-spinner__item loading-spinner__item--2"></div><div class="loading-spinner__item loading-spinner__item--3"></div></div></div></div></div>',
            template: '<div class="popover js-dynamic-popover" role="tooltip">' +
                '<div class="popover-arrow"></div>' +
                '<h3 class="popover-header"></h3>' +
                '<div class="popover-body">' +
                '</div></div>'
        });
    } else {
        new Popover(element, {
            html: true,
            trigger: 'focus'
        });
    }
});

import * as rangeSlider from '@elements/range-slider';
onFind('.js-range-slider', function (slider) {
    rangeSlider.createRangeSlider(slider, {
        onSet: (sliderObj) => {
            addClass('is-selected', slider);

            findIn('.js-range-slider__val-display', slider).value = sliderObj.values[0] + ' - ' + sliderObj.values[1];

            if (slider.getAttribute('data-input-group')) {
                findAll('input[name="'+ slider.getAttribute('data-input-group') +'"]').map((input) => input.checked = false)
            }
        },
        onUpdate: (sliderObj) => {
            let value = sliderObj.value,
                decimalPlaces = sliderObj.decimalPlaces;

            if ( sliderObj.handle === 0 ) {
                findIn('.js-range-slider__val-min', slider).value = value.toFixed(decimalPlaces);
            } else {
                findIn('.js-range-slider__val-max', slider).value = value.toFixed(decimalPlaces);
            }
        }
        }, {
        slider: '.js-range-slider__slider',
        inputMin: '.js-range-slider__min',
        inputMax: '.js-range-slider__max'
    });
});

import * as productNumberSpinner from './scripts/product-number-spinner'
productNumberSpinner.init();

import * as products from './scripts/product-item'
products.init();

import * as overlay from './scripts/overlay'
overlay.init();

import * as dynamicModal from './scripts/dynamic-modal'
dynamicModal.init();

import {createAffix} from "@elements/affix";
if (matchMedia('(min-width: 768px)').matches) {
    onFind('.js-affix-sidebar', ((affixElement) => {
        let elementHeight = affixElement.getBoundingClientRect().height;
        if (elementHeight + affixElement.getAttribute('data-affix-offset') > window.innerHeight) {
            return
        }
        createAffix(affixElement, {}, {
            base: '.js-affix-sidebar',
            placeholder: '.js-affix-sidebar__placeholder',
            container: '.js-affix-sidebar__container'
        });
    }));
}

import * as video from './scripts/video';
video.init();

import * as reloadSelect from './scripts/reload-select';
reloadSelect.init();

import * as lightbox from '@elements/lightbox';
lightbox.init({
    mobileSettings: {
        controls: true,
        showCloseIcon: true
    }
});